import { getUrlFromFileId } from '../utilities/formsUtilities';
const locationTypes = [
    { name: 'Circus', label: 'Circus' },
    { name: 'CombinedArts', label: 'Combined Arts' },
    { name: 'Comedy', label: 'Comedy' },
    { name: 'CommunitySpace', label: 'Community Space' },
    { name: 'Craft', label: 'Craft' },
    { name: 'Dance', label: 'Dance' },
    { name: 'Festival', label: 'Festival' },
    { name: 'Educational', label: 'Educational' },
    { name: 'FamilyFriendly', label: 'Family Friendly' },
    { name: 'FilmCinema', label: 'Film/Cinema' },
    { name: 'Gallery', label: 'Gallery' },
    { name: 'ImmersiveAndVR', label: 'Immersive and VR' },
    { name: 'Library', label: 'Library' },
    { name: 'LiteraturePoetry', label: 'Literature and Poetry' },
    { name: 'Museum', label: 'Museum' },
    { name: 'Music', label: 'Music' },
    { name: 'Theatre', label: 'Theatre' },
    { name: 'VisitorAttraction', label: 'Visitor Attraction' },
    { name: 'VisualArt', label: 'Visual Art' }
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processLocationData = (_locationData) => {
    let locData, draftLocData, provisionData;
    let locationData = _locationData.location_data;
    if (!locationData) {
        return false;
    }
    locData = [
        { name: 'photo1', type: 'file', title: 'Location', value: locationData.photo1, required: true },
        { name: 'photo2', type: 'file', title: 'Location', value: locationData.photo2 },
        { name: 'photo3', type: 'file', title: 'Location', value: locationData.photo3 },
        { name: 'name', type: 'text', title: `Name`, value: _locationData.name, 'required': true },
        { name: 'language', type: 'select', title: 'Language', value: locationData.language, options: languages },
        { name: 'address1', type: 'text', title: `Street address`, value: locationData.address1, 'required': true },
        { name: 'address2', type: 'text', title: `Address Line 2`, value: locationData.address2 },
        { name: 'city', type: 'text', title: `City`, value: locationData.city, 'required': true },
        { name: 'country', type: 'text', title: `Country`, value: locationData.country, 'required': true },
        { name: 'postcode', type: 'text', title: `Postcode`, value: locationData.postcode, 'required': true },
        { name: 'phone', type: 'text', title: `Phone`, value: locationData.phone },
        { name: 'email', type: 'email', title: `Email`, value: locationData.email },
        { name: 'website', type: 'url', title: `Website`, value: locationData.website, 'required': true },
        { name: 'description', type: 'textarea', title: `Description`, value: locationData.description, 'required': true },
        { name: 'type', type: 'multiselect', title: `What artforms does this location offer?`, value: locationData.type, 'required': true, options: locationTypes },
        { name: 'accessInformation', type: 'url', title: `Access information URL`, value: locationData.accessInformation },
        { name: 'videoUrl', type: 'url', title: `Familiarisation tour URL`, value: locationData.videoUrl },
        { name: 'videoDescription', type: 'text', title: `Familiarisation tour description`, value: locationData.videoDescription, requiredIf: 'videoUrl' },
        { name: 'visualStory', type: 'url', title: `Visual Story URL`, value: locationData.visualStory },
        { name: 'accessAble', type: 'url', title: `AccessAble URL`, value: locationData.accessAble },
        { name: 'euansGuide', type: 'url', title: `Euan's Guide URL`, value: locationData.euansGuide },
        { name: 'acceptCeaCard', type: 'checkbox', title: `Accept CEA Card`, value: locationData.acceptCeaCard },
        { name: 'acceptNimbusCard', type: 'checkbox', title: `Accept Access Card`, value: locationData.acceptNimbusCard },
        { name: 'acceptSunflowerLanyard', type: 'checkbox', title: `Accept Sunflower Lanyards`, value: locationData.acceptSunflowerLanyard },
        { name: 'allInScheme', type: 'checkbox', title: `Part of All In`, value: locationData.allInScheme },
        { name: 'requiresProofOfEligibility', type: 'checkbox', title: `Require proof of eligibility`, value: locationData.requiresProofOfEligibility },
    ];
    provisionData = {};
    if (locationData.hasOwnProperty('draftInfo') && locationData.draftInfo && locationData.approvalStatus == 'AwaitingResponse') {
        if (typeof locationData.draftInfo === 'string') {
            locationData.draftInfo = JSON.parse(locationData.draftInfo);
        }
        let photo1 = {};
        if (locationData.draftInfo.photo1PublicUrl) {
            photo1 = { publicUrl: locationData.draftInfo.photo1PublicUrl };
        }
        else if (locationData.photo1 && locationData.photo1.id) {
            photo1 = locationData.photo1;
        }
        if (locationData.draftInfo.photo1AltText) {
            photo1.altText = locationData.draftInfo.photo1AltText;
        }
        let photo2 = {};
        if (locationData.draftInfo.photo2PublicUrl) {
            photo2 = { publicUrl: locationData.draftInfo.photo2PublicUrl };
        }
        else if (locationData.photo2 && locationData.photo2.id) {
            photo2 = locationData.photo2;
        }
        if (locationData.draftInfo.photo2AltText) {
            photo2.altText = locationData.draftInfo.photo2AltText;
        }
        let photo3 = {};
        if (locationData.draftInfo.photo3PublicUrl) {
            photo3 = { publicUrl: locationData.draftInfo.photo3PublicUrl };
        }
        else if (locationData.photo3 && locationData.photo3.id) {
            photo3 = locationData.photo3;
        }
        if (locationData.draftInfo.photo3AltText) {
            photo3.altText = locationData.draftInfo.photo3AltText;
        }
        draftLocData = [
            { name: 'photo1', type: 'file', title: 'Location', value: photo1, required: true },
            { name: 'photo2', type: 'file', title: 'Location', value: photo2 },
            { name: 'photo3', type: 'file', title: 'Location', value: photo3 },
            { name: 'name', type: 'text', title: `Name`, value: locationData.draftInfo.name, 'required': true },
            { name: 'language', type: 'select', title: 'Language', value: locationData.draftInfo.language, options: languages },
            { name: 'address1', type: 'text', title: `Street Address`, value: locationData.draftInfo.address1, 'required': true },
            { name: 'address2', type: 'text', title: `Address Line 2`, value: locationData.draftInfo.address2 },
            { name: 'city', type: 'text', title: `City`, value: locationData.draftInfo.city, 'required': true },
            { name: 'country', type: 'text', title: `Country`, value: locationData.draftInfo.country, 'required': true },
            { name: 'postcode', type: 'text', title: `Postcode`, value: locationData.draftInfo.postcode, 'required': true },
            { name: 'phone', type: 'text', title: `Phone`, value: locationData.draftInfo.phone },
            { name: 'email', type: 'email', title: `Email`, value: locationData.draftInfo.email },
            { name: 'website', type: 'url', title: `Website`, value: locationData.draftInfo.website, 'required': true },
            { name: 'description', type: 'textarea', title: `Description`, value: locationData.draftInfo.description, 'required': true },
            { name: 'type', type: 'multiselect', title: `What artforms does this location offer?`, value: locationData.draftInfo.type, 'required': true, options: locationTypes },
            { name: 'accessInformation', type: 'url', title: `Access information URL`, value: locationData.draftInfo.accessInformation },
            { name: 'videoUrl', type: 'url', title: `Familiarisation tour URL`, value: locationData.draftInfo.videoUrl },
            { name: 'videoDescription', type: 'text', title: `Familiarisation tour description`, value: locationData.draftInfo.videoDescription, requiredIf: 'videoUrl' },
            { name: 'visualStory', type: 'url', title: `Visual Story URL`, value: locationData.draftInfo.visualStory },
            { name: 'accessAble', type: 'url', title: `AccessAble URL`, value: locationData.draftInfo.accessAble },
            { name: 'euansGuide', type: 'url', title: `Euan's Guide URL`, value: locationData.draftInfo.euansGuide },
            { name: 'acceptCeaCard', type: 'checkbox', title: `Accpet CEA Card`, value: locationData.draftInfo.acceptCeaCard },
            { name: 'acceptNimbusCard', type: 'checkbox', title: `Accept Access Card`, value: locationData.draftInfo.acceptNimbusCard },
            { name: 'acceptSunflowerLanyard', type: 'checkbox', title: `Accept Sunflower Lanyards`, value: locationData.draftInfo.acceptSunflowerLanyard },
            { name: 'allInScheme', type: 'checkbox', title: `Part of All In`, value: locationData.draftInfo.allInScheme },
            { name: 'requiresProofOfEligibility', type: 'checkbox', title: `Require proof of eligibility`, value: locationData.draftInfo.requiresProofOfEligibility },
        ];
    }
    else {
        draftLocData = [];
    }
    if (_locationData.provisions) {
        provisionData = Object.entries(_locationData.provisions);
        provisionData = provisionData?.map((provision) => {
            provision = provision[1];
            provision.provisions = provision.provisions.map((item) => {
                if (item.hasOwnProperty('provision_data')) {
                    return {
                        name: item.standard?.name,
                        id: item.standard?.id,
                        image: item.provision_data.photo?.publicUrl,
                        imageId: item.provision_data.photo?.id,
                        alt: item.provision_data.photo?.altText,
                        description: item.provision_data?.description,
                        draft: item.provision_data?.draft,
                    };
                }
                else {
                    return {
                        name: item.name,
                        id: item.id,
                        image: item.image,
                        imageId: item.imageId,
                        alt: item.alt,
                        description: item.description,
                        draft: item.draft,
                    };
                }
            });
            return provision;
        });
    }
    return {
        locData: locData,
        draftLocData: draftLocData,
        provisionData: provisionData
    };
};
export { processLocationData, locationTypes };
